import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=44cba343"
import script from "./Subtitle.vue?vue&type=script&lang=ts"
export * from "./Subtitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports